<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <!-- start: PAGE TITLE -->
      <section id="page-title" style="background-color: #d1d1d1">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">Edit Role</h1>
          </div>
          <div class="col-sm-2">
            <router-link class="btn btn-primary" :to="{ name: 'all-roles' }">Back</router-link>
          </div>
        </div>
      </section>
      <!-- end: PAGE TITLE -->
      <!-- start: DYNAMIC TABLE -->
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <!-- <div class="col-md-12 mt-5"> -->
          <form class="text-start mx-auto" @submit.prevent="editRole" enctype="multipart/form-data">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>Role Name</label>
                  <input type="text" class="form-control" placeholder="Enter Role Name" v-model="name" />
                  <span class="error text-small block" v-if="errors.name">{{
                    errors.name }}</span>
                </div>
              </div>

              <!-- Multi-select for Permissions -->
              <div class="col-md-12 mb-5">
                <div class="mb-5">
                  <div class="form-group mb-5">
                    <label>Select Permissions</label>
                    <multiselect v-model="selectedPermissions" :options="permissions" :multiple="true"
                      :searchable="true" label="name" track-by="id" :close-on-select="false" :clear-on-select="false"
                      :position="'bottom'" placeholder="Select permissions">
                    </multiselect>
                    <span class="error text-small block" v-if="errors.selectedPermissions">{{
                      errors.selectedPermissions }}</span>
                  </div>
                </div>
              </div>

            </div>
            <button class="btn btn-primary">Submit</button>
          </form>
          <!-- </div> -->
        </div>
      </div>
      <!-- end: DYNAMIC TABLE -->
    </div>
  </div>
</template>

<script>
import axios from "../../Axios";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.css";
export default {
  name: "EditRole",
  components: {
    Multiselect,
  },
  data() {
    return {
      name: "",
      permissions: [],
      selectedPermissions: [],  // Selected permissions
      errors: {},
    };
  },
  created() {
    this.fetchRole();
    this.fetchPermissions();
  },
  methods: {
    validateForm() {
      this.errors = {};
      if (!this.name) {
        this.errors.name = "Name is required.";
      }
      if (this.selectedPermissions.length === 0) {
        this.errors.selectedPermissions = "Permissions are required.";
      }
      return Object.keys(this.errors).length === 0;
    },
    async fetchPermissions() {
      try {
        const token = localStorage.getItem("access_token");
        const response = await axios.get("/admin/admin/permission/all", {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        console.log('permissions', response.data.data);
        this.permissions = response.data.data;
      } catch (error) {
        console.error(error);
      }
    },

    async fetchRole() {
      try {
        const token = localStorage.getItem("access_token");
        console.log('fetching the permissions')
        const response = await axios.get(
          "/admin/admin/role/get?id=" + this.$route.params.id
          , {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
        console.log('role', response.data.data);

        this.name = response.data.data.name;
        // this.permissions = response.data.data.permissions.id;
        // this.permission_id = response.data.data.permissions.id;
        this.selectedPermissions = response.data.data.permissions;

        console.log(response.data.data);
      } catch (error) {
        console.error(error);
        if (error.response && error.response.status === 422) {
          // Handle validation errors
          this.errors = error.response.data.errors;
          console.log("Validation errors:", this.errors);
        } else {
          console.error("Error creating doctor:", error);
        }
      }
    },
    async editRole() {
      try {
        if (!this.validateForm()) {
          return;
        }
        const formData = new FormData();
        formData.append("id", this.$route.params.id);
        formData.append("name", this.name);
        this.selectedPermissions.forEach((permission, index) => {
          formData.append(`permissions[${index}]`, permission.id);
        });
        const token = localStorage.getItem("access_token");
        const response = await axios.post(
          "admin/admin/role/update",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              'Authorization': `Bearer ${token}`,
            },
          }
        );

        console.log(formData);
        console.log(response.data);
        this.$router.push({ name: "all-roles" });
      } catch (error) {
        console.error(error);
      }
    },
  },
};

</script>


<style scoped>
/* Remove scoped and move these styles globally */
.multiselect {
  position: relative;
  z-index: 999;
}

.multiselect__content-wrapper {
  position: absolute !important;
  z-index: 1000 !important;
  width: 100% !important;
  background: white !important;
  max-height: 200px !important;
  overflow-y: auto !important;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1) !important;
  border: 1px solid #e8e8e8 !important;
  top: 100% !important;
  left: 0 !important;
}


form {
  padding: 1rem;
  border: 1px solid #ccc;
  background-color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 100%;
}

.form-group {
  margin-bottom: 1.5rem;
}

button {
  width: 100%;
}

.error {
  color: #a94442;
  font-size: 0.875em;
}

.wrap-content {
  padding-bottom: 3rem;
  padding-top: 3rem;
  margin-bottom: 3rem;
  height: 100vh;
}

.app-content {
  padding-bottom: 2rem;
  height: 100vh;
}
</style>
